export const MAIN_ROUTES = {
  game: `/game`,
  login: `/login`,
  register: `/register`,
  forgot: `/forgot-password`,
  changePassword: `/forgot-password/change-password`,
  verification: `/verification-user`,
  changeSocialUsername: `/oauth/change-social-username`,
  completeRegistration: `/complete-registration`,
  lobby: `/lobby`,
  tournaments: `/tournaments`,
  ladder: `/ladder`,
  forum: `/forum`,
  help: `/help`,
  userInfo: `/user-info`,
  editAccount: `/edit-account`,
  tickets: `/tickets`,
  invites: `/invites`,
  logout: `/logout`,
  gameColony: `https://gamecolony.com`,
};
